import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[appTableRowContent]',
    standalone: false
})
export class  TableRowContentDirective {

  @HostBinding('class')
  className = 'app-table-row-content';
}
